import { Component } from '@angular/core';

@Component({
  templateUrl: './control-panel.page.html',
})

/**
 * Control panel page
 */
export class ControlPanelPage {}
